import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon, Pagination } from '@node-space/ui-components'
import { PageHeader } from 'components/header/PageHeader'
import { useSimplePagination } from 'hooks/useSimplePagination'
import mockInvoicesJson from '../../../__mocks__/Billing/invoices.json'
import { BillingTable } from './BillingTable'
import type { Invoice } from './types'

const mockInvoices = mockInvoicesJson as Invoice[]

export const Billing = () => {
  const { t } = useTranslation()
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = useSimplePagination()

  const paginatedInvoices = useMemo(() => {
    const start = page * rowsPerPage
    return mockInvoices.slice(start, start + rowsPerPage)
  }, [page, rowsPerPage])

  return (
    <>
      <PageHeader
        description={t('billing.description')}
        renderRightSection={
          <Button variant="ghost" iconElement={<Icon name="Eye" />} onClick={() => {}}>
            {t('billing.seeFeeStructure')}
          </Button>
        }
      />

      <BillingTable invoices={paginatedInvoices} isLoading={false} />

      <Box paddingT={16}>
        <Pagination
          testId="billing-pagination"
          page={page}
          rowsPerPage={rowsPerPage}
          total={mockInvoices.length}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    </>
  )
}
